import {
  TagFragment,
  Button,
  Collection,
  Facts,
  Features,
  Iframe,
  Media,
  Press,
  Presses,
  PullQuote,
  Table,
  TeaserBlock,
  Video,
  VideoExternal
} from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const queryArticle = graphql(
  /* GraphQL */ `
    query Article($slug: String) {
      article(filter: { slug: { eq: $slug } }) {
        _seoMetaTags {
          ...TagFragment
        }
        __typename
        _modelApiKey
        createdAt
        category {
          id
          name
          slug
        }
        id
        excerpt
        leadText
        body {
          blocks {
            ... on RecordInterface {
              id
              _modelApiKey
              __typename
            }
            ...Button
            ...Collection
            ...Facts
            ...Features
            ...Iframe
            ...Media
            ...Press
            ...Presses
            ...PullQuote
            ...Table
            ...TeaserBlock
            ...Video
            ...VideoExternal
          }
          links {
            ... on RecordInterface {
              _modelApiKey
              __typename
              id
            }
            ... on ArticleRecord {
              slug
              title
            }
            ... on PageRecord {
              slug
              title
            }
            ... on WorkRecord {
              slug
              title
            }
          }
          value
        }
        image {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "21:9", w: 1440 }
          ) {
            ...ResponsiveImage
          }
        }
        readTime
        title
        slug
      }
      articleCommonSection {
        sections {
          id
          title
          description
          disclaimer
          invertColorTheme
          thankYouMessage
        }
      }
    }
  `,
  [
    TagFragment,
    Button,
    Collection,
    Facts,
    Features,
    Iframe,
    Media,
    Press,
    Presses,
    PullQuote,
    Table,
    TeaserBlock,
    Video,
    VideoExternal
  ]
)
